import { styled } from "@mui/material/styles";
import Colors from "src/general/constants/colors";

export const Link = styled("a")({
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	gap: "8px",
	width: "201px",
	height: "32px",
	cursor: "pointer",
});

export const Text = styled("p")({
	fontStyle: "normal",
	fontWeight: 500,
	fontSize: "20px",
	lineHeight: "32px",
	whiteSpace: "nowrap",
	textOverflow: "ellipsis",
	overflow: "hidden",
	color: Colors.BLACK,
	margin: 0,
	padding: 0,
});